var browser   = require("bowser").getParser(window.navigator.userAgent),
    config    = require("app/config"),
    osName    = browser.getOSName().toLocaleLowerCase(),
    themeVars = require("app/theme/variables.js");

module.exports = {
    ajaxWithCredentials:             config.radiantMediaPlayer.signedCookies,
    allowLocalStorage:               true,
    audioOnly:                       true,
    audioOnlyUseAudioLayout:         true,
    automaticFullscreenOnLandscape:  false,
    autoplay:                        false,
    capLevelToPlayerSize:            true,
    consumeLessEnergy:               true,
    dashFirst:                       !(osName === "macos" || osName === "ios"),
    detectViewerLanguage:            false,
    doubleClickForFullscreen:        false,
    fadeInPlayer:                    false,
    fullWindowSkin:                  true,
    iconsSet:                        themeVars.RadiantMP.iconSet,
    iconsSize:                       (1 / 1.2),
    licenseKey:                      config.radiantMediaPlayer.key,
    pip:                             false,
    preload:                         "auto",
    quickForward:                    10,
    quickRewind:                     10,
    rememberCurrentTime:             false,
    rememberQuality:                 true,
    rememberVolume:                  true,
    requestAutoplayCapabilitiesData: false,
    sharing:                         false,
    skin:                            "s2",
    skinAccentColor:                 themeVars.RadiantMP.skinAccentColor,
    skinBackgroundColor:             themeVars.RadiantMP.skinBackgroundColor,
    skinButtonColor:                 themeVars.RadiantMP.skinButtonColor,
    speed:                           true,
    speedRates:                      [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2],
    srcChangeAutoplay:               false,
    strictGdprCompliance:            true
};
